<template>
  <el-input
    v-model="inputValue"
    @click="visible = true"
    @clear="handleClear"
    :placeholder="$t('common.pleaseSelect')"
    clearable
    v-bind="$attrs"
  />
  <h-dialog :title="$t('common.selectShop')" v-model="visible" width="800px" @on-ok="handleSubmit">
    <div class="content">
      <el-radio-group v-model="selectRow">
        <h-table
          ref="tableRef"
          vuexNamespace="choose-shop-btn"
          :http="getTableData"
          :columns="columns"
          :query-form="queryForm"
          :show-reset="false"
          :show-query="false"
          pagPayout="prev, pager, next"
          pagSize="small"
          row-key="id"
          style="height: 500px;"
          @result="getTableResult"
        >
          <template #checked="{ row }">
            <el-radio :value="row"></el-radio>
          </template>
        </h-table>
      </el-radio-group>
    </div>
  </h-dialog>
</template>

<script setup>
import { ref, watch } from 'vue'
import { shopList } from '@/api/order-manager/sale-order.js'
import { $t } from '@/i18n'

const modelValue = defineModel()
const $emit = defineEmits(['change'])

const inputValue = ref()
const visible = ref(false)
const selectRow = ref()

const tableData = ref([])
const getTableData = (params) => {
  params.enabled = 1
  params.bound = 1
  return shopList(params)
}
const getTableResult = (res) => {
  tableData.value = res.data.rows
}

watch(() => modelValue.value, (val) => {
  if (val) {
    const row = tableData.value.find(item => item.id === val)
    if (row) {
      selectRow.value = row
      inputValue.value = row.shop_name
    }
  } else {
    selectRow.value = void 0
    inputValue.value = ''
  }
})


const handleSubmit = () => {
  modelValue.value = selectRow.value.id
  $emit('change')
  inputValue.value = selectRow.value.shop_name
  visible.value = false
}

const handleClear = () => {
  modelValue.value = ''
  inputValue.value = void 0
  $emit('change')
}

/* 列名 */
const columns = [
  {
    prop: 'checked',
    minWidth: 50,
    label: '',
    scopedSlots: 'checked',
    showOverflowTooltip: true
  },
  {
    prop: 'shop_name',
    label: $t('home.ranking.shopName'),
    minWidth: 200,
    showOverflowTooltip: true
  },
  {
    prop: 'cabinet_code',
    label: $t('TODO.cabinetCode'),
    minWidth: 250,
    showOverflowTooltip: true
  },
  {
    prop: 'org_name',
    label: $t('common.org'),
    minWidth: 200,
    showOverflowTooltip: true
  }
]

/* 查询 form */
const queryForm = ref({
  formItems: [
    {
      key: 'name_or_code',
      type: 'input',
      placeholder: $t('commonComponents.selectShopCabinet')
    }
  ]
})
</script>

<style scoped lang="scss">
.content {
  height: 650px;

  .el-radio-group {
    display: block;
  }
}

:deep(.el-row) {
  .form-row {
    min-width: 100%;
    padding-right: 10px !important;
  }
}
</style>